import { useState, useRef, useEffect } from "react";

export const useBoundingRect = () => {
  const ref = useRef();
  const [bbox, setBbox] = useState({});

  useEffect(() => {
    const set = () => {
      setBbox(ref.current ? ref.current.getBoundingClientRect() : {});
    };

    set();
    window.addEventListener("resize", set);
    return () => window.removeEventListener("resize", set);
  }, []);

  return [bbox, ref];
};
